import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

interface CardProps extends HTMLAttributes<HTMLDivElement> {}

/** Panel surface: `ds-panel`, 1-px `ds-line` border, soft `shadow-ds`, 14-px radius. */
export function Card({ className, ...props }: CardProps) {
  return <div className={cn("rounded-ds-lg border border-ds-line bg-ds-panel shadow-ds", className)} {...props} />;
}
